'use client';

import React, { useEffect, useRef } from 'react';
import ReviewTitleCard from './review-title-card';
import { UserReview } from '@prisma/client';
import { cn } from "@/lib/utils"

interface ScrollingCardsProps {
  reviews: UserReview[];
  className?: string;
  primaryBackgroundColour: string;
  cardStyle: string | null;
}

const ScrollingCards: React.FC<ScrollingCardsProps> = ({ reviews, className, primaryBackgroundColour, cardStyle }) => {
  const scrollRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    let interval: NodeJS.Timeout;

    if (scrollRef.current) {
      const el = scrollRef.current;
      interval = setInterval(() => {
        if (el.scrollLeft >= el.scrollWidth - el.clientWidth) {
          el.scrollLeft = 0;
        } else {
          el.scrollLeft += 1;
        }
      }, 50);
    }

    return () => {
      clearInterval(interval);
    };
  }, [scrollRef]);

  return (
    <div ref={scrollRef} 
    className={cn(
        "overflow-x-hidden overflow-y-visible whitespace-nowrap py-1",
        className
      )}>
      {Array(5) // Duplicate array for infinite scrolling effect
        .fill(reviews)
        .flat()
        .map((review, index) => (
          <ReviewTitleCard key={index} title={review.title} primaryBackgroundColour={primaryBackgroundColour} cardStyle={cardStyle} />
        ))}
    </div>
  );
};

export default ScrollingCards;